import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Avatar,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Container,
  IconButton,
} from "@mui/material";
import { ConsultantuseAuth } from "../../security/ConsultantUseAuth";
import { ArrowBack, ArrowForward } from "@mui/icons-material";

import { Consultant_Get_One_From_MongoDB } from "../../api/Consultant_Get_One_From_MongoDB";
import GetClientAddress from "../../../functions/GetClientAddress";
import { Get_One_From_MongoDB } from "../../api/Get_One_From_MongoDB";
import { Consultant_Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort } from "../../api/Consultant_Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort";
import { Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort } from "../../api/Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort";

import { Get_All_From_MongoDB_With_Search_Prop_In_Array } from "../../api/Get_All_From_MongoDB_With_Search_Prop_In_Array";
import ConsultantInvoicesTable from "./components/ConsultantInvoicesTable";
import ConsultantInvoicesCards from "./components/ConsultantInvoicesCards";
import { Get_One_Choose_Fields_From_MongoDB } from "../../api/Get_One_Choose_Fields_From_MongoDB";
import { Get_All_From_MongoDB_Choose_Fields_With_Search_Prop_In_Array } from "../../api/Get_All_From_MongoDB_Choose_Fields_With_Search_Prop_In_Array";
import { Get_All_Non_Archived_Attendees_From_Array } from "../../api/Get_All_Non_Archived_Attendees_From_Array";

const ConsultantInvoices = () => {
  const { logoutConsultant } = ConsultantuseAuth();

  //------------------------------------------Width Stuff

  let widthLimit = 1000;
  const [screenWidth, setscreenWidth] = useState(
    window.innerWidth <= widthLimit ? "Small" : "Big"
  );

  useEffect(() => {
    const handleResize = () => {
      setscreenWidth(window.innerWidth <= widthLimit ? "Small" : "Big");
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  function isMobile() {
    return (
      /Mobi|Android|iPhone|iPad|iPod|BlackBerry|Opera Mini|IEMobile|WPDesktop/i.test(
        navigator.userAgent
      ) || screenWidth === "Small"
    );
  }

  const [View, setView] = useState(isMobile() ? "Cards" : "Table");

  //-----------------------width stuff--------------

  function handleOpenOfficialWebsite() {
    window.open(`https://investin.org`);
  }
  function handleOpenBespokeForm() {
    window.open(
      `${GetClientAddress()}Public/RegistrationForm/${localStorage.getItem(
        "Consultant_id"
      )}`
    );
  }
  function handleOpenSXPSite() {
    window.open(`https://investin.org/collections/summer-schools`);
  }

  //----------------------------------------------------------

  //Get EC Data
  const [obj_EC, setobj_EC] = useState({});
  useEffect(() => {
    const fetchECData = async () => {
      Get_One_From_MongoDB(
        "IP",
        "EC",
        localStorage.getItem("Consultant_id"),
        setobj_EC,
        logoutConsultant
      );
    };
    fetchECData();
  }, []);

  //Get Agency Data
  const [obj_Agency, setobj_Agency] = useState({});
  useEffect(() => {
    if (obj_EC.MetaData?.Agency_id && obj_EC.MetaData.Agency_id.length > 0) {
      Get_One_Choose_Fields_From_MongoDB(
        "IP",
        "Agencies",
        obj_EC.MetaData.Agency_id,
        {
          "MetaData.IP_id": 1,
          _id: 1,
          BasicInfo: 1,
        },
        setobj_Agency
      );
    }
  }, [obj_EC]);
  //Get All ECs if Admin
  const [Arr_ECs, setArr_ECs] = useState([]);
  useEffect(() => {
    if (obj_EC.MetaData?.Admin === "Yes") {
      const fetchAttendeeData = async () => {
        Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort(
          "IP",
          "EC",
          { "MetaData.Agency_id": obj_EC.MetaData?.Agency_id },
          100,
          setArr_ECs,
          {},
          { _id: 1, BasicInfo: 1 },
          logoutConsultant
        );
      };
      fetchAttendeeData();
    }
  }, [obj_EC]);
  //Part 1, get bookings data
  const [Arr_Bookings, setArr_Bookings] = useState([]);
  useEffect(() => {
    const fetchAttendeeData = async () => {
      if (obj_EC.MetaData?.Admin === "Yes") {
        let Arr_ECs_IDs = Arr_ECs.map((obj) => obj._id);
        Get_All_Non_Archived_Attendees_From_Array(
          "Registers_2025",
          "All",
          "IPInfo.EC_ID",
          Arr_ECs_IDs,
          {
            _id: 1,
            BasicInfo: 1,
            Contacts: 1,
            IPInfo: 1,
            SEFProgress: 1,
            VISA: 1,
            SEFInfo: 1,
            Notes: 1,
          },
          setArr_Bookings,
          logoutConsultant
        );
      } else {
        Get_limited_Choose_Fields_From_MongoDB_With_Search_With_Sort(
          "Registers_2025",
          "All",
          {
            "IPInfo.EC_ID": localStorage.getItem("Consultant_id"),
           "MetaData.Archived": { $ne: "Yes" },
          },
          1000,
          setArr_Bookings,
          {},
          {
            _id: 1,
            BasicInfo: 1,
            Contacts: 1,
            IPInfo: 1,
            SEFProgress: 1,
            VISA: 1,
            SEFInfo: 1,
            Notes: 1,
          },
          logoutConsultant
        );
      }
    };
    fetchAttendeeData();
  }, [obj_EC, Arr_ECs]);

  //part 2, get all id's from bookings
  const getCompiledArray = async () => {
    // Wait for the state to update
    return new Promise((resolve) => {
      setTimeout(() => {
        let Arr_Bookingid = Arr_Bookings.map((obj) => obj._id);
        resolve(Arr_Bookingid);
      }, 0);
    });
  };

  //part 3, use the id's from bookings to find all invoices
  const [Arr_Invoices, setArr_Invoices] = useState([]);
  const fetchInvoiceData = async () => {
    const compiledArray = await getCompiledArray();

    Get_All_From_MongoDB_With_Search_Prop_In_Array(
      "Invoices",
      "Xero_2025",
      "Attendees.Attendee_id",
      compiledArray,
      setArr_Invoices,
      logoutConsultant
    );
  };

  useEffect(() => {
    const fetchData = async () => {
      // Part 1: Fetch attendee data
      //await fetchAttendeeData();
      // Part 2: Get all IDs from bookings
      const compiledArray = await getCompiledArray();
      // Part 3: Use the IDs from bookings to find all invoices
      await fetchInvoiceData(compiledArray);
    };
    fetchData();
  }, [Arr_Bookings]);

  //----------------------------------Filter and Sort

  //filter out any onvoice with Paid_Status of "Voided" or "Credited"
  let Arr_Invoices_Filtered = Arr_Invoices.filter(
    (invoice) =>
      invoice.Paid_Status !== "Voided" && invoice.Paid_Status !== "Credited"
  );

  let Arr_Invoices_Filtered_Sorted = React.useMemo(() => {
    let sortableItems = [...Arr_Invoices_Filtered];
    sortableItems.sort((a, b) => {
      if (a.Paid_Status === "Paid" && b.Paid_Status !== "Paid") {
        return 1;
      } else if (b.Paid_Status === "Paid" && a.Paid_Status !== "Paid") {
        return -1;
      } else if (a.Due_Date > b.Due_Date) {
        return 1;
      } else if (a.Due_Date <= b.Due_Date) {
        return -1;
      } else {
        return 0;
      }
    });

    return sortableItems;
  }, [Arr_Invoices_Filtered]);

  //a fucntion that, when given an invoice, which has multiple values in the array called "Attendees", will find all attendees (with that ID in the Arr_Bookings array and return all of their names as one string
  const getAttendeeNames = (invoice) => {
    let Arr_AttendeeNames = [];
    console.log("GET NAMES");
    if (invoice.Attendees) {
      invoice.Attendees.forEach((Attendee) => {
        let obj_Attendee = Arr_Bookings.find(
          (Booking) => Booking._id === Attendee.Attendee_id
        );

        if (obj_Attendee) {
          Arr_AttendeeNames.push(
            (obj_Attendee.BasicInfo?.First_Name || "First Name TBC") +
              " " +
              (obj_Attendee.BasicInfo?.Last_Name || "Last Name TBC")
          );
        }
      });
      return Arr_AttendeeNames.join(", ");
    } else {
      return "";
    }
  };

  //--------------------------------------------------
  return (
    <div>
      <link rel="stylesheet" href="https://www.w3schools.com/w3css/4/w3.css" />
      <link
        rel="stylesheet"
        href="https://www.w3schools.com/lib/w3-theme-black.css"
      />
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
      />
      <style jsx>{`
        #BookingTable {
          font-family: Arial, Helvetica, sans-serif;
          border-collapse: collapse;
          width: 100%;
        }

        #BookingTable td,
        #BookingTable th {
          border: 1px solid #ddd;
          padding: 8px;
        }

        #BookingTable tr:nth-child(even) {
          background-color: #ffffff;
        }

        #BookingTable tr:hover {
          background-color: #ddd;
        }

        #BookingTable th {
          padding-top: 12px;
          padding-bottom: 12px;
          background-color: #04aa6d;
          color: white;
        }
      `}</style>

      {/* <!-- Bookings --> */}
      <div
        className="w3-row-padding w3-padding-64 w3-theme-l5 w3-center"
        id="Bookings"
        style={{ position: "relative", minHeight: "100vh" }}
      >
        <h1>Your Invoices</h1>
        <p>
          Here you can see all of your invoices that are assigned to you.
          <br></br>
          <br></br>
          Please note that all invoices are manually reviewed before being
          recorded as "Paid", so if you have recently paid an invoice, it may
          take a few days to update here.
          <br></br>
          <br></br>
          If you expected to see an invoice here and it is not, please contact
          us so we can properly create one.
        </p>
        {View === "Table" ? (
          <button onClick={(e) => setView("Cards")} style={{ width: "25%" }}>
            Cards View
          </button>
        ) : (
          <button onClick={(e) => setView("Table")} style={{ width: "25%" }}>
            Table View
          </button>
        )}
        <br></br>
        <br></br>
        {View === "Table" ? (
          <>
            <ConsultantInvoicesTable
              Arr_Invoices={Arr_Invoices_Filtered_Sorted}
              obj_EC={obj_EC}
              Arr_ECs={Arr_ECs}
              getAttendeeNames={getAttendeeNames}
            />
          </>
        ) : (
          <>
            <ConsultantInvoicesCards
              Arr_Invoices={Arr_Invoices_Filtered_Sorted}
              obj_EC={obj_EC}
              Arr_ECs={Arr_ECs}
              screenWidth={screenWidth}
              getAttendeeNames={getAttendeeNames}
            />
          </>
        )}
      </div>

      {/* <!-- Footer --> */}
      <footer className="w3-container w3-padding-32 w3-theme-d1 w3-center">
        <h4>Follow Us</h4>
        <a
          className="w3-button w3-large w3-teal"
          href="https://www.facebook.com/@investineducation/"
          title="Facebook"
        >
          <i className="fa fa-facebook"></i>
        </a>
        <a
          className="w3-button w3-large w3-teal"
          href="https://twitter.com/investin_ed"
          title="Twitter"
        >
          <i className="fa fa-twitter"></i>
        </a>

        <a
          className="w3-button w3-large w3-teal"
          href="https://www.instagram.com/investin_education/?hl=en"
          title="Instagram"
        >
          <i className="fa fa-instagram"></i>
        </a>
        <a
          className="w3-button w3-large w3-teal w3-hide-small"
          href="https://uk.linkedin.com/company/investin"
          title="Linkedin"
        >
          <i className="fa fa-linkedin"></i>
        </a>
        <a
          className="w3-button w3-large w3-teal"
          href="https://investin.org/"
          title="Website"
        >
          <i className="fa fa-globe"></i>
        </a>
      </footer>
    </div>
  );
};

export default ConsultantInvoices;
